var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWatermarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33.491,
    height: 45.669,
    viewBox: "0 0 33.491 45.669",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_371",
    "data-name": "Rectangle 371",
    width: 15.471,
    height: 22.599,
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_300",
    "data-name": "Group 300",
    transform: "translate(-295 -129.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11644",
    "data-name": "Path 11644",
    d: "M16.745,0A16.911,16.911,0,0,1,33.491,17.072c0,9.428-16.745,28.6-16.745,28.6s-2.17-2.484-5.223-6.463C6.859,33.13,0,23.106,0,17.072A16.911,16.911,0,0,1,16.745,0Z",
    transform: "translate(295 129.5)",
    fill: "#5792cc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_294",
    "data-name": "Group 294",
    transform: "translate(200.223 -263.203)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11592",
    "data-name": "Path 11592",
    d: "M1706.341,74.109l-1.308,1.936-1.534,1.71-1.018,2.447-1.277,2.85s-.789,2.393.447,3.878a6.487,6.487,0,0,0,4.035,2.288c1.739.457,3.919-1.227,3.919-1.227l1.72-2.338V81.64l-2.7-4.406Z",
    transform: "translate(-1590.204 330.826)",
    fill: "#5792cc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_274",
    "data-name": "Group 274",
    transform: "translate(107.655 400.194)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_272",
    "data-name": "Group 272",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11590",
    "data-name": "Path 11590",
    d: "M5.208.055a7.188,7.188,0,0,1-.5,1.158q-.4.789-.825,1.559C3.277,3.867,2.64,4.944,2.011,6.026c-.236.406-.473.811-.7,1.224A13.429,13.429,0,0,0,.567,8.933,6.106,6.106,0,0,0,.66,14.261a5.732,5.732,0,0,0,1.862,1.88,4.946,4.946,0,0,0,2.8.756.193.193,0,0,0,0-.386,4.784,4.784,0,0,1-2.469-.63,5.343,5.343,0,0,1-1.7-1.574,4.457,4.457,0,0,1-.774-2.375A7.326,7.326,0,0,1,.868,9.2a13.347,13.347,0,0,1,.741-1.731c.2-.388.422-.769.638-1.15.6-1.059,1.213-2.112,1.786-3.186.3-.57.607-1.145.866-1.737A6.271,6.271,0,0,0,5.355.1.076.076,0,0,0,5.208.055",
    transform: "translate(3.257 3.256)",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11591",
    "data-name": "Path 11591",
    d: "M150.035.1a5.57,5.57,0,0,0,.389,1.156c.221.509.473,1.005.728,1.5.569,1.1,1.187,2.166,1.8,3.238A22.213,22.213,0,0,1,154.3,8.634c.673,1.66,1.1,3.608.186,5.267a5.258,5.258,0,0,1-1.776,1.872,4.82,4.82,0,0,1-2.767.734c-.25-.006-.247.373,0,.386a4.942,4.942,0,0,0,2.562-.547,5.731,5.731,0,0,0,1.862-1.566,4.8,4.8,0,0,0,.982-2.336,6.7,6.7,0,0,0-.277-2.762,15.33,15.33,0,0,0-1.494-3.307c-.613-1.061-1.238-2.115-1.841-3.182-.336-.594-.666-1.192-.971-1.8a8.429,8.429,0,0,1-.588-1.336.076.076,0,0,0-.147.041",
    transform: "translate(-141.556 3.256)",
    stroke: "#000",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_11593",
    "data-name": "Path 11593",
    d: "M1706.341,74.109l-1.308,1.936-1.534,1.71-1.018,2.447-1.277,2.85s-.789,2.393.447,3.878a6.487,6.487,0,0,0,4.035,2.288c1.739.457,3.919-1.227,3.919-1.227l1.72-2.338V81.64l-2.7-4.406Z",
    transform: "translate(-1597.883 327.335)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_273",
    "data-name": "Group 273",
    transform: "translate(99.919 396.703)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_272-2",
    "data-name": "Group 272",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11590-2",
    "data-name": "Path 11590",
    d: "M5.208.055a7.188,7.188,0,0,1-.5,1.158q-.4.789-.825,1.559C3.277,3.867,2.64,4.944,2.011,6.026c-.236.406-.473.811-.7,1.224A13.429,13.429,0,0,0,.567,8.933,6.106,6.106,0,0,0,.66,14.261a5.732,5.732,0,0,0,1.862,1.88,4.946,4.946,0,0,0,2.8.756.193.193,0,0,0,0-.386,4.784,4.784,0,0,1-2.469-.63,5.343,5.343,0,0,1-1.7-1.574,4.457,4.457,0,0,1-.774-2.375A7.326,7.326,0,0,1,.868,9.2a13.347,13.347,0,0,1,.741-1.731c.2-.388.422-.769.638-1.15.6-1.059,1.213-2.112,1.786-3.186.3-.57.607-1.145.866-1.737A6.271,6.271,0,0,0,5.355.1.076.076,0,0,0,5.208.055",
    transform: "translate(3.257 3.256)",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11591-2",
    "data-name": "Path 11591",
    d: "M150.035.1a5.57,5.57,0,0,0,.389,1.156c.221.509.473,1.005.728,1.5.569,1.1,1.187,2.166,1.8,3.238A22.213,22.213,0,0,1,154.3,8.634c.673,1.66,1.1,3.608.186,5.267a5.258,5.258,0,0,1-1.776,1.872,4.82,4.82,0,0,1-2.767.734c-.25-.006-.247.373,0,.386a4.942,4.942,0,0,0,2.562-.547,5.731,5.731,0,0,0,1.862-1.566,4.8,4.8,0,0,0,.982-2.336,6.7,6.7,0,0,0-.277-2.762,15.33,15.33,0,0,0-1.494-3.307c-.613-1.061-1.238-2.115-1.841-3.182-.336-.594-.666-1.192-.971-1.8a8.429,8.429,0,0,1-.588-1.336.076.076,0,0,0-.147.041",
    transform: "translate(-141.556 3.256)",
    stroke: "#000",
    strokeWidth: 1
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatermarker);
export default __webpack_public_path__ + "static/media/water marker.06968bf598c863516bc3276315356e2f.svg";
export { ForwardRef as ReactComponent };